import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext';
import { DataContext } from '../contexts/DataContext';
import AppPage from '../layouts/AppPage';
import styled from 'styled-components';
import { parseMarkDownLinks } from '../lib/utils/parse';
import { DEFAULT_TITLE } from '../lib/settings';
import { metaTags } from '../lib/utils/metaTags';

export default function About() {
  const { api } = useContext(AuthContext);
  const { about, setAbout } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (about) return;
    const getAbout = async () => {
      setIsLoading(true);
      try {
        const response = await api.getAbout();
        setAbout(response.data[0]);
      } catch (error) {
      };
      setIsLoading(false);
    };
    getAbout();
  }
  , [api, about, setAbout]);

  const MetaTags = useMemo(() => {
    let description = '';
    if (about && about.length > 0) {
      description = about.map(contact => `${contact.title} ${contact.url}`).join(' | ');
    }
    return metaTags({
      title: `${DEFAULT_TITLE} | Контакты`,
      description: description,
      image: '',
      url: 'https://chimeras.world/contacts/'
    })
  }, [about]);
  
  return (
    <AppPage>
      {MetaTags}
      {!isLoading && about?.content &&
      <Wrapper>
        <h2>контакты</h2>
        <div className="about">
          {about.content.split('\n').map((item, index) => (
            <p key={index} dangerouslySetInnerHTML={{__html: parseMarkDownLinks(item)}}></p>
          ))}
        </div>
      </Wrapper>
      }
    </AppPage>
  )
}

const Wrapper = styled.div`
  padding: 50px 20px 0 20px;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  & h2 {
    font-size: 1.125rem;
    font-weight: 700;
    font-family: var(--primary-font);
  }

  p {
    font-size: 1rem;
    font-family: var(--secondary-font);
    min-height: 1rem;
  }

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: 768px) {
    margin-top: 4rem;
    padding: 0 var(--main-side-padding);

    p {
      font-size: 1.25rem;
    }
  }
`;